import React, { useState, useEffect } from 'react';
import BackButtonBottom from '../../components/common/BackButtonBottom';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getMyDamageClaims, damageClaimStatusBadge } from '../../services/disputeService';
import toast from 'react-hot-toast';

export default function MyDamageClaims() {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userProfile?.id) return;
    getMyDamageClaims(userProfile.id, 'driver')
      .then(setClaims)
      .catch((err) => toast.error(err.message || 'Could not load claims'))
      .finally(() => setLoading(false));
  }, [userProfile?.id]);

  const fmtDate = (ts) => {
    if (!ts) return '';
    const d = ts._seconds ? new Date(ts._seconds * 1000) : new Date(ts);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <div className="max-w-[700px] mx-auto p-6">
      <div className="mb-4">
        <button onClick={() => navigate('/driver')} className="bg-transparent border-0 text-brand-primary font-semibold text-[0.9rem] cursor-pointer p-0">← Dashboard</button>
      </div>

      <h1 className="font-serif mt-0 mb-2">Damage claims</h1>
      <p className="text-body text-[0.9rem] mb-4">
        Claims you've submitted for damage or cleaning.
      </p>

      <button onClick={() => navigate('/driver/submit-damage-claim')} className="w-full p-3 rounded-xl cursor-pointer font-semibold mb-4"
        style={{ border: '1.5px dashed #2dd4a8', background: '#f0fdfa', color: '#0a8270' }}>+ Submit a new claim</button>

      {loading && <div className="p-10 text-center text-muted">Loading...</div>}

      {!loading && claims.length === 0 && (
        <div className="p-10 text-center text-muted bg-white rounded-2xl border border-slate-200">
          No damage claims submitted yet.
        </div>
      )}

      <div className="grid gap-3">
        {claims.map(c => {
          const badge = damageClaimStatusBadge(c.status);
          return (
            <div key={c.id} onClick={() => navigate(`/driver/claims/${c.id}`)} className="p-4 rounded-2xl bg-white border border-slate-200 cursor-pointer transition-all">
              <div className="flex justify-between items-start mb-1.5">
                <div>
                  <div className="font-bold text-brand-dark">{c.referenceNumber}</div>
                  <div className="text-[0.78rem] text-muted capitalize">{c.type}</div>
                </div>
                <span className="px-2.5 py-[3px] rounded-full text-[0.7rem] font-bold" style={{ background: badge.bg, color: badge.color }}>
                  {badge.label}
                </span>
              </div>
              <div className="text-[0.85rem] text-body mb-2">
                {c.description?.substring(0, 100)}{c.description?.length > 100 ? '...' : ''}
              </div>
              <div className="flex justify-between text-[0.82rem]">
                <span className="text-body">
                  Claimed: <strong>${c.amountClaimed?.toFixed(2)}</strong>
                  {c.approvedAmount && c.approvedAmount !== c.amountClaimed && (
                    <> · Approved: <strong style={{ color: '#059669' }}>${c.approvedAmount.toFixed(2)}</strong></>
                  )}
                </span>
                <span className="text-muted">{fmtDate(c.submittedAt)}</span>
              </div>
            </div>
          );
        })}
      </div>
      <BackButtonBottom to="/driver" label="Dashboard" />
    </div>
  );
}